const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_BASE_DELAY_MS = 400;

const wait = (ms, signal) =>
  new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Aborted', 'AbortError'));
      return;
    }

    const timeoutId = setTimeout(() => {
      signal?.removeEventListener?.('abort', onAbort);
      resolve();
    }, ms);

    const onAbort = () => {
      clearTimeout(timeoutId);
      reject(new DOMException('Aborted', 'AbortError'));
    };

    signal?.addEventListener?.('abort', onAbort, { once: true });
  });

const isAbortError = (error) => error?.name === 'AbortError';

export const retryAsync = async (
  operation,
  {
    maxAttempts = DEFAULT_MAX_ATTEMPTS,
    baseDelayMs = DEFAULT_BASE_DELAY_MS,
    signal,
    shouldRetry
  } = {}
) => {
  let attempt = 0;
  let lastError;

  while (attempt < maxAttempts) {
    attempt += 1;

    try {
      return await operation({ attempt });
    } catch (error) {
      lastError = error;

      if (isAbortError(error) || signal?.aborted) {
        throw error;
      }

      const canRetry = attempt < maxAttempts && (shouldRetry ? shouldRetry(error, attempt) : true);

      if (!canRetry) {
        throw error;
      }

      const delay = baseDelayMs * attempt;

      try {
        await wait(delay, signal);
      } catch (waitError) {
        throw waitError;
      }
    }
  }

  throw lastError;
};
